module.exports = __webpack_public_path__ + "img/ai6@2x.c6c3d5e2.png";